var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "40px 15px 40px 15px",
        "background-color": "#2D2D2D"
      }
    },
    [
      _c(
        "el-col",
        {
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { span: 24 }
        },
        [
          _c("img", {
            staticStyle: { width: "343px", height: "179px" },
            attrs: {
              loading: "lazy",
              src: require("../../assets/advertisement-3.jpg")
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45fa4812", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45fa4812","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/advertisementThree.vue
// module id = null
// module chunks = 